// extracted by mini-css-extract-plugin
module.exports = {"conversation":"style_conversation__28KWI","empty-conversations":"style_empty-conversations__1_1Ss"};